import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Wallet,
  BarChart3,
  DollarSign,
  Target,
  Settings,
  Eye,
  GraduationCap,
} from "lucide-react";

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const menuItems = [
    { path: "/dashboard", icon: BarChart3, label: "Dashboard" },
    { path: "/transactions", icon: DollarSign, label: "Transaction" },
    { path: "/goals", icon: Target, label: "Goals" },
    { path: "/charts", icon: BarChart3, label: "Graphics" },
    {
      path: "/finance-school",
      icon: GraduationCap,
      label: "Finance School",
    },
    { path: "/education", icon: Settings, label: "Education" },
    { path: "/profile", icon: Eye, label: "Profile" },
  ];

  return (
    <div className="hidden lg:block w-80 bg-white/5 backdrop-blur-xl border-r border-white/10">
      <div className="p-6">
        <div className="flex items-center space-x-3 mb-8">
          <div className="w-12 h-12 bg-gradient-to-r from-emerald-400 to-blue-500 rounded-2xl flex items-center justify-center">
            <Wallet className="w-7 h-7 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-white">GreenTracker</h1>
            <p className="text-gray-400 text-sm">Financial Control</p>
          </div>
        </div>

        <div className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`w-full flex items-center space-x-3 p-3 rounded-xl transition-colors ${
                  isActive(item.path)
                    ? "bg-white/10 text-white"
                    : "text-gray-300 hover:bg-white/5"
                }`}
              >
                <Icon className="w-5 h-5" />
                <span>{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
